import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonVideoPlayerWidget } from '@eforall/common';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { FuncService } from '../../../../services';

export interface VideoDialogData {
	type: 'applicationParticipant' | 'volunteer',
	personId: number,
	uniqueVideoId: number,
}

@Component({
	selector: 'video-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		CommonVideoPlayerWidget
	],
	templateUrl: './video.dialog.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './video.dialog.scss'
})

export class VideoDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<VideoDialog>);
	public dialogContext: DialogContext<VideoDialogData> = inject(MAT_DIALOG_DATA);

	private readonly dialogService = inject(DialogService);
	private readonly func = inject(FuncService);

	public signedVideoUrl = signal<string>('');

	public actions: DialogAction[] = [{
		id: 'close',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Close'),
		linkType: 'no-action',
		willCloseDialog: true,
	}];

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (!data || !data.uniqueVideoId || !data.personId) return;

		const fileData = await this.func.videoRecording.getVideo({
			personId: data.personId,
			videoId: data.uniqueVideoId,
			type: data.type,
		});

		if (fileData && fileData.url) {
			this.signedVideoUrl.set(fileData.url);
		}

	}

	onVideoError() {
		this.dialogService.showMessage('Error', 'The video URL is invalid or the video is not available.', 'Okay', [], 400, 200);
	}
}